<template>
  <ibox>
    <template slot="title">企業登録</template>
    <template slot="body">
      <company-form/>
    </template>
  </ibox>
</template>

<script>
  import CompanyForm from '../../components/company/Form.vue'

  export default {
    data () {
      return {}
    },
    components: {
      CompanyForm
    }
  }
</script>




// WEBPACK FOOTER //
// Create.vue?67801d2b